import { Routes } from '@angular/router';
import { accessLevelGuard } from '@organisations/guards/access-level/access-level.guard';

import { AssessmentFormComponent } from './components/organisation/assessment-form/assessment-form.component';
import { BusinessHoursComponent } from './components/organisation/business-hours/business-hours.component';
import { LeadsLinkComponent } from './components/organisation/leads-link/leads-link.component';
import { ServiceTypesComponent } from './components/organisation/service-types/service-types.component';
import { NotificationsComponent } from './components/user/notifications/notifications.component';
import { OrganisationInvitesComponent } from './components/user/organisation-invites/organisation-invites.component';
import { ProfileComponent } from './components/user/profile/profile.component';
import { SettingsOrganisationComponent } from './pages/settings-organisation/settings-organisation.component';
import { SettingsUserComponent } from './pages/settings-user/settings-user.component';
import { SettingsComponent } from './pages/settings/settings.component';

export enum SettingsRoutes {
	ORGANISATION = 'organisation',
	USER = 'user',
}

export enum OrganisationSettingsRoutes {
	BUSINESS_HOURS = 'business-hours',
	SERVICE_TYPES = 'service-types',
	ASSESSMENT_FORM = 'assessment-form',
	LEADS_LINK = 'leads-link',
}

export enum UserSettingsRoutes {
	PROFILE = 'profile',
	NOTIFICATIONS = 'notifications',
	ORGANISATION_INVITES = 'organisation-invites',
}

export const settingsRoutes: Routes = [
	{
		path: '',
		component: SettingsComponent,
		children: [
			{
				path: '',
				redirectTo: SettingsRoutes.USER,
				pathMatch: 'full',
			},
			{
				path: SettingsRoutes.USER,
				component: SettingsUserComponent,
				title: 'ServeOx | User Settings',
				children: [
					{
						path: '',
						redirectTo: UserSettingsRoutes.PROFILE,
						pathMatch: 'full',
					},
					{
						path: UserSettingsRoutes.PROFILE,
						component: ProfileComponent,
					},
					{
						path: UserSettingsRoutes.NOTIFICATIONS,
						component: NotificationsComponent,
					},
					{
						path: UserSettingsRoutes.ORGANISATION_INVITES,
						component: OrganisationInvitesComponent,
					},
					{
						path: '**',
						redirectTo: UserSettingsRoutes.PROFILE,
					},
				],
			},
			{
				path: SettingsRoutes.ORGANISATION,
				component: SettingsOrganisationComponent,
				title: 'ServeOx | Organisation Settings',
				canActivate: [accessLevelGuard],
				children: [
					{
						path: '',
						redirectTo: OrganisationSettingsRoutes.BUSINESS_HOURS,
						pathMatch: 'full',
					},
					{
						path: OrganisationSettingsRoutes.BUSINESS_HOURS,
						component: BusinessHoursComponent,
					},
					{
						path: OrganisationSettingsRoutes.SERVICE_TYPES,
						component: ServiceTypesComponent,
					},
					{
						path: OrganisationSettingsRoutes.ASSESSMENT_FORM,
						component: AssessmentFormComponent,
					},
					{
						path: OrganisationSettingsRoutes.LEADS_LINK,
						component: LeadsLinkComponent,
					},
					{
						path: '**',
						redirectTo: OrganisationSettingsRoutes.BUSINESS_HOURS,
					},
				],
			},
			{
				path: '**',
				redirectTo: SettingsRoutes.USER,
			},
		],
	},
	{
		path: '**',
		redirectTo: '',
	},
];
